/** Inscription institution — fusionné dans institutionOverlay (fr/en). */

export const institutionRegisterStringsFr: Record<string, string> = {
  'auth.institutionRegister': 'Inscription institution',
  'auth.institutionRegister.pageTitle': 'Inscription institution',
  'auth.institutionRegister.steps.institution': 'Institution',
  'auth.institutionRegister.steps.contact': 'Contact',
  'auth.institutionRegister.steps.plan': 'Plan',
  'auth.institutionRegister.institutionName': "Nom de l'institution *",
  'auth.institutionRegister.institutionNamePlaceholder': 'Université de Paris',
  'auth.institutionRegister.typeLabel': "Type d'institution *",
  'auth.institutionRegister.sizeLabel': "Taille (nombre d'apprenants) *",
  'auth.institutionRegister.selectPlaceholder': 'Sélectionner…',
  'auth.institutionRegister.type.university': 'Université',
  'auth.institutionRegister.type.school': 'École',
  'auth.institutionRegister.type.training_center': 'Centre de formation',
  'auth.institutionRegister.type.enterprise': 'Entreprise',
  'auth.institutionRegister.type.association': 'Association',
  'auth.institutionRegister.type.other': 'Autre',
  'auth.institutionRegister.size.1_50': '1 – 50',
  'auth.institutionRegister.size.51_200': '51 – 200',
  'auth.institutionRegister.size.201_1000': '201 – 1 000',
  'auth.institutionRegister.size.1000_plus': '1 000+',
  'auth.institutionRegister.firstName': 'Prénom *',
  'auth.institutionRegister.lastName': 'Nom *',
  'auth.institutionRegister.workEmail': 'E-mail professionnel *',
  'auth.institutionRegister.workEmailPlaceholder': 'admin@institution.fr',
  'auth.institutionRegister.phone': 'Téléphone',
  'auth.institutionRegister.phonePlaceholder': '+33 1 23 45 67 89',
  'auth.institutionRegister.planIntro': 'Choisissez le plan adapté à vos besoins :',
  'auth.institutionRegister.plan.pro.name': 'Pro',
  'auth.institutionRegister.plan.pro.price': '49€/mois',
  'auth.institutionRegister.plan.pro.f0': "Jusqu'à 10 formateurs",
  'auth.institutionRegister.plan.pro.f1': '100 apprenants',
  'auth.institutionRegister.plan.pro.f2': 'Support e-mail',
  'auth.institutionRegister.plan.enterprise.name': 'Enterprise',
  'auth.institutionRegister.plan.enterprise.price': '199€/mois',
  'auth.institutionRegister.plan.enterprise.f0': 'Formateurs illimités',
  'auth.institutionRegister.plan.enterprise.f1': '1 000 apprenants',
  'auth.institutionRegister.plan.enterprise.f2': 'Support prioritaire',
  'auth.institutionRegister.plan.institution.name': 'Institution',
  'auth.institutionRegister.plan.institution.price': 'Sur devis',
  'auth.institutionRegister.plan.institution.f0': 'Tout illimité',
  'auth.institutionRegister.plan.institution.f1': 'SSO & LMS',
  'auth.institutionRegister.plan.institution.f2': 'Account manager dédié',
  'auth.institutionRegister.previous': 'Précédent',
  'auth.institutionRegister.next': 'Suivant',
  'auth.institutionRegister.sending': 'Envoi…',
  'auth.institutionRegister.createAccount': 'Créer le compte',
};

export const institutionRegisterStringsEn: Record<string, string> = {
  'auth.institutionRegister': 'Institution sign-up',
  'auth.institutionRegister.pageTitle': 'Institution sign-up',
  'auth.institutionRegister.steps.institution': 'Organization',
  'auth.institutionRegister.steps.contact': 'Contact',
  'auth.institutionRegister.steps.plan': 'Plan',
  'auth.institutionRegister.institutionName': 'Organization name *',
  'auth.institutionRegister.institutionNamePlaceholder': 'e.g. City University',
  'auth.institutionRegister.typeLabel': 'Organization type *',
  'auth.institutionRegister.sizeLabel': 'Size (number of learners) *',
  'auth.institutionRegister.selectPlaceholder': 'Select…',
  'auth.institutionRegister.type.university': 'University',
  'auth.institutionRegister.type.school': 'School',
  'auth.institutionRegister.type.training_center': 'Training center',
  'auth.institutionRegister.type.enterprise': 'Company',
  'auth.institutionRegister.type.association': 'Non-profit / association',
  'auth.institutionRegister.type.other': 'Other',
  'auth.institutionRegister.size.1_50': '1 – 50',
  'auth.institutionRegister.size.51_200': '51 – 200',
  'auth.institutionRegister.size.201_1000': '201 – 1,000',
  'auth.institutionRegister.size.1000_plus': '1,000+',
  'auth.institutionRegister.firstName': 'First name *',
  'auth.institutionRegister.lastName': 'Last name *',
  'auth.institutionRegister.workEmail': 'Work email *',
  'auth.institutionRegister.workEmailPlaceholder': 'admin@organization.com',
  'auth.institutionRegister.phone': 'Phone',
  'auth.institutionRegister.phonePlaceholder': '+1 555 123 4567',
  'auth.institutionRegister.planIntro': 'Choose the plan that fits your needs:',
  'auth.institutionRegister.plan.pro.name': 'Pro',
  'auth.institutionRegister.plan.pro.price': '€49/month',
  'auth.institutionRegister.plan.pro.f0': 'Up to 10 trainers',
  'auth.institutionRegister.plan.pro.f1': '100 learners',
  'auth.institutionRegister.plan.pro.f2': 'Email support',
  'auth.institutionRegister.plan.enterprise.name': 'Enterprise',
  'auth.institutionRegister.plan.enterprise.price': '€199/month',
  'auth.institutionRegister.plan.enterprise.f0': 'Unlimited trainers',
  'auth.institutionRegister.plan.enterprise.f1': '1,000 learners',
  'auth.institutionRegister.plan.enterprise.f2': 'Priority support',
  'auth.institutionRegister.plan.institution.name': 'Institution',
  'auth.institutionRegister.plan.institution.price': 'Custom pricing',
  'auth.institutionRegister.plan.institution.f0': 'Everything unlimited',
  'auth.institutionRegister.plan.institution.f1': 'SSO & LMS',
  'auth.institutionRegister.plan.institution.f2': 'Dedicated account manager',
  'auth.institutionRegister.previous': 'Back',
  'auth.institutionRegister.next': 'Next',
  'auth.institutionRegister.sending': 'Sending…',
  'auth.institutionRegister.createAccount': 'Create account',
};
